import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import VendorExitFreespinsState from "../../../vendor_core/src/states/VendorExitFreespinsState";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { Tween } from "../../../vendor_core/core/src/Tween";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIModes, UIStates } from "../../../vendor_core/core/src/ui/UIStates";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import GameSoundVars from "../enums/GameSoundVars";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import VendorModel from "../../../vendor_core/src/model/VendorModel";
import BackgroundHelper from "../view/background/BackgroundHelper";
import { Ease } from "../../../vendor_core/core/src/Ease";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import { Timeline } from "../../../vendor_core/core/src/Timeline";
import App from "../../../vendor_core/core/src/App";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import Locale from "../../../vendor_core/core/src/utils/Locale";
import KeyboardManager from "../../../vendor_core/core/src/utils/KeyboardManager";

export default class SaSExitFreespinsState extends VendorExitFreespinsState {
    private outroAnimDuration: number = 5;
    private isSceneClosed = false;
    private sceneName: string = "";
    private spineSkin: string = "";
    public enter() {
        // Set popup
        this.sceneName = SpinModel.featureMode === 2 ? "freespinssummaryBH1" : "freespinssummaryBH2";
        this.spineSkin = SpinModel.featureMode === 2 ? "sticky" : "black";
        VendorModel.spinStartTime = 0;
        super.enter();
        ViewManager.getLayer("FreespinCounter").clear();
        this.isSceneClosed = false;
    }

    public showPopup() {
        App.dispatcher.emit(GameEvents.SHOW_FREE_SPIN_OUTRO);
        SoundController.playSound(`${GameSoundVars.FREE_SPINS_COMPLETED}_${SpinModel.featureMode - 1}`);
        ViewManager.getLayer("SplashOverlay").setScene("open");
        //  this.winMusic = SoundController.playSound(GameSoundVars.FREESPINS_END_POPUP,false,null,false);
        const scene = ViewManager.getLayer(DefaultLayers.Popups).setScene(this.sceneName);
        CommandManager.execute(Commands.UPDATE_FREE_SPINS);
        scene.interactive = true;


        let explosionEffect = scene.spineAnimations.get("fsIntroOutro");
        explosionEffect.setAnimationSkin(this.spineSkin);
        explosionEffect.playAsync("outro_start").then(() => explosionEffect.playAsync("outro_loop"));
        let headerTxt = scene.sceneTextFields.get("header");
        headerTxt.alpha = 0;
        let title2 = scene.sceneTextFields.get("title2");
        title2.alpha = 0;
        const hasWin = SpinModel.accumulatedWin > 0;
        headerTxt.text = Locale.getString(hasWin ? "fs_summary_header" : "exit_free_games_title");
        title2.text = Locale.getString(hasWin ? "gui_exit_free_games_data" : "gui_exit_free_games_data_loss");

        let winMoney = scene.sceneMoneyFields.get("win_counter");
        winMoney.value = SpinModel.accumulatedWin;
        winMoney.alpha = 0;
        let timeline = new Timeline({
            autoRemoveChildren: false,
            onComplete: () => {
                // to use it when autoplay mode is complete
                // Tween.delayedCall(this.outroAnimDuration, () => {
                //     if (!this.isSceneClosed) {
                //         timeline.reverse(0);
                //         explosionEffect.playAsync("outro_end")
                //             .then(() => {
                //                 this.closePopup(scene);
                //                 timeline.clear;
                //                 timeline.kill();
                //             });
                //     }
                // });
            }
        });

        timeline
            .to(headerTxt, 0.5, { delay: 0, alpha: 1, ease: Ease.Power4In }, 0)
            .to(title2, 0.8, { delay: 0, alpha: 1, ease: Ease.Power4In }, 0)
            .to(winMoney, 1.2, { delay: 0, alpha: hasWin ? 1 : 0, ease: Ease.Power4In }, 0)

        timeline.play();
        Tween.delayedCall(2, () => {
            scene.once(PointerEvents.DOWN, () => {
                App.dispatcher.emit(GameEvents.FREE_SPIN_OUTRO_CLOSED);
                timeline.reverse(0);
                explosionEffect.playAsync("outro_end")
                    .then(() => {
                        this.closePopup(scene);
                        timeline.progress = 1;
                        timeline.clear;
                        timeline.kill();
                    });
            })
        });


    }

    public closePopup(scene: SceneView) {
        if (!this.isSceneClosed) {

            KeyboardManager.enable();
            this.isSceneClosed = true;

            let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
                .getCurrentScene()
                .getSubView("ReelGroup") as ReelGroup;
            reelGroup.winSymbolsView.unlockAll();
            reelGroup.winSymbolsView.stopAll();
            reelGroup.hideLinesAndInfo(true);
            ViewManager.getLayer(DefaultLayers.Popups).clear();

            if (SpinModel.featureMode == 2) {
                ViewManager.getLayer("Multipliers").clear();
            }
            BackgroundHelper.backgroundLoop();

            ViewManager.getLayer("SplashOverlay").clear();
            SpinModel.exitFreespins();

            if (this.winMusic) {
                SoundController.stopSound(this.winMusic);
            }

            const bgImgs = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene().sceneSprites;
            bgImgs.forEach(img => img.visible = false);
            bgImgs.get("Front_Objects_MG").visible = true;

            SpinModel.featureMode = -1;
            reelGroup.revealAllSymbols();
            scene.destroy();

            this.exit();
        }
    }

}
